import fullConfigCurrentCompanyRequest from "./requests/full-config-current-company-request";
import getByNameRequest from "./requests/get-by-name-request";

const configRepository = {
    fullConfigCurrentCompany: fullConfigCurrentCompanyRequest,
    getByName: getByNameRequest,
};

export default configRepository;